import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';
import { ApiConnectService } from './api-connect.service';
import { StandardPinConfiguration, StandardPinScope, StandardPinUpdate, StandardPinEditorSnapshot } from '../models/standard-pin.model';
import { GroupContext } from '../models/group-context.model';

const PIN_PATH = '/common/standard-pins';
const SCOPES_PATH = '/scopes';
const GROUP_PARAMETER = 'groupId';
const EMPTY_TEXT = '';
const PATH_SEPARATOR = '/';
const CONTEXT_PATH = '/context';
const EDITOR_PATH = '/editor';
const STANDARD_PARAMETER = 'standardId';

@Injectable()
export class StandardPinService {
  constructor(private http: HttpClient, private api: ApiConnectService) {}

  scopes(groupId: string): Observable<StandardPinScope[]> {
    const params = new HttpParams().set(GROUP_PARAMETER, groupId || EMPTY_TEXT);
    return this.http.get<StandardPinScope[]>(this.api.baseApiUrl + PIN_PATH + SCOPES_PATH, {params: params});
  }

  read(scopeId: string): Observable<StandardPinConfiguration> {
    return this.http.get<StandardPinConfiguration>(this.scopeUrl(scopeId));
  }

  editor(standardId: string): Observable<StandardPinEditorSnapshot> {
    const params = new HttpParams().set(STANDARD_PARAMETER, standardId);
    return this.http.get<StandardPinEditorSnapshot>(this.api.baseApiUrl + PIN_PATH + EDITOR_PATH, {params: params});
  }

  context(groupId: string): Observable<GroupContext> {
    return this.http.get<GroupContext>(this.api.groupContext + encodeURIComponent(groupId) + CONTEXT_PATH);
  }

  save(scopeId: string, update: StandardPinUpdate): Observable<StandardPinConfiguration> {
    return this.http.put<StandardPinConfiguration>(this.scopeUrl(scopeId), update);
  }

  private scopeUrl(scopeId: string): string {
    return this.api.baseApiUrl + PIN_PATH + PATH_SEPARATOR + encodeURIComponent(scopeId);
  }
}



// WEBPACK FOOTER //
// C:/work/internal-frontend/src/app/services/standard-pin.service.ts